var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { default as React, Component } from "react";
import { bind } from "decko";
import { Portal } from "../components/portal";
import { Panel } from "../components/panel";
import { FlexContainer } from "../grid/flexcontainer";
import { serviceUrl } from "../helper/serviceurl";
import { Grid } from "../grid/grid";
import { Icon } from "../components/icon";
import { menuTranslations } from "./i18n/index";
import { Button } from "../components/button";
export default class SessionExpiredPortal extends Component {
    handleVisibilityChange() {
        if (!document.hidden) {
            this.props.onWindowVisible && this.props.onWindowVisible();
        }
        else {
            this.props.onWindowHidden && this.props.onWindowHidden();
        }
    }
    componentDidMount() {
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
    }
    componentWillUnmount() {
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    render() {
        const translate = menuTranslations();
        return (React.createElement(Portal, { coverAllTheThings: true },
            React.createElement(Panel, null,
                React.createElement(Grid, { columnSpec: [
                        [80, "px"],
                        [1, "fr"],
                    ] },
                    React.createElement(FlexContainer, { direction: "col", paddingX: "md", paddingY: "xxl" },
                        React.createElement(Icon, { name: "warning", color: "secondary1", colorType: "default", size: "xxl" })),
                    React.createElement(FlexContainer, { direction: "col", paddingX: "md", paddingY: "md", spaceBetween: "lg" },
                        React.createElement("h1", null, translate.sessionExpired.title),
                        React.createElement("p", null, translate.sessionExpired.paragraph),
                        React.createElement(FlexContainer, { spaceBetween: "md" },
                            React.createElement(Button, { type: "primary", onClick: () => window.open(serviceUrl("login", "?closeOnLogin")) }, translate.sessionExpired.goToLogin)))))));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SessionExpiredPortal.prototype, "handleVisibilityChange", null);
//# sourceMappingURL=SessionExpiredPortal.js.map